module.exports = __webpack_public_path__ + "static/img/1056_small.cae5e8e.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/1056_small.png
// module id = shic
// module chunks = 1